// kapigen version 0.1.34
// eslint-disable
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { UserAchievementTierWireFormat3 as KaggleSdkUsersUserAchievementTierWireFormat3 } from "../../users";
var defaultCategory = {
    id: 0,
    name: "",
    fullPath: "",
    description: "",
    datasetCount: 0,
    competitionCount: 0,
    scriptCount: 0,
    slug: "",
    displayName: ""
};
export var CategoryWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCategory, wireFormat);
        return message;
    }
};
var defaultOrganization = {
    name: ""
};
export var OrganizationWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultOrganization, wireFormat);
        return message;
    }
};
var defaultUser = {
    id: 0,
    displayName: "",
    imageThumbName: "",
    userName: ""
};
export var UserWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUser, wireFormat);
        if (wireFormat) {
            message.performanceTier = KaggleSdkUsersUserAchievementTierWireFormat3.fromJson(wireFormat.performanceTier);
        }
        return message;
    }
};
